export default __webpack_public_path__ + "static/media/logo.85acf075.png";